const defaultFetch = (url, options) => {
    return fetch(url, { credentials: "include", mode: "cors", ...options });
};
const railsCsrfFetch = (url, { headers, ...rest }) => {
    return fetch(url, {
        headers: { ...headers, "X-CSRF-Token": inferRailsCsrfToken() },
        ...rest,
        credentials: "include",
        mode: "cors",
    });
};
function inferRailsCsrfToken() {
    var _a, _b;
    return (((_a = window === null || window === undefined ? undefined : window.Rails) === null || _a === undefined ? undefined : _a.csrfToken()) ||
        ((_b = document
            .querySelector('meta[name="csrf-token"]')) === null || _b === undefined ? undefined : _b.getAttribute("content")) ||
        null);
}
function apiRequest(fetch, url, { method = "GET", data = null } = {}) {
    const options = {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        method,
        redirect: "follow",
    };
    if (data && method !== "GET") {
        options.body = JSON.stringify(data);
    }
    return fetch(url, options).then((response) => response
        .json()
        .then((json) => ({ json, ok: response.ok, response }))
        .catch(() => ({ json: null, ok: response.ok, response })), (e) => {
        console.warn(e);
        return { json: null, ok: false, response: null };
    });
}

export { apiRequest as default, defaultFetch, railsCsrfFetch };
//# sourceMappingURL=api_request.js.map
